module.exports = __webpack_public_path__ + "img/cyms.f58e1a93.svg";